import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';
import { TenantBaseService } from '@app/shared/services/tenant-base.service';
import { EnabledFeatureFlagsDTO } from '@cco/feature-flags-model';
import { Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService extends TenantBaseService {
  private http = inject(HttpClient);

  constructor() {
    const config = inject<AppConfig>(APP_CONFIG);

    super(config.apiBaseUrl);
  }

  /**
   * Also carries {@link EnabledFeatureFlagsDTO#cognitoConfigured}, which isn't a feature flag but
   * rides the same tenant-scoped, load-once-at-login call rather than a dedicated endpoint.
   */
  getEnabledFeatureFlags$(): Observable<EnabledFeatureFlagsDTO> {
    return this.tenantBaseUrl$.pipe(
      switchMap(baseUrl => this.http.get<EnabledFeatureFlagsDTO>(`${baseUrl}/feature-flags`)),
    );
  }
}
